import { AccountInfo } from "@azure/msal-browser";
import {newRoleType} from "../../manage-roles/AddRolePopup";
import {newUserType} from "../../manage-users/AddUser";
import {postData} from "./base";

interface newUserPayloadType extends newUserType {
    azureUserId: string,
}

export async function addCompanyState (
    endpoint: string, data :object, accounts: AccountInfo[]) {
    const res = await postData(endpoint, data, accounts);
    return res;
}

export async function addFacilityType (data: object, accounts: AccountInfo[]) {
    const res = await postData(`CompanyDetail`, data, accounts);
    return res;
}

export async function addCompany (data: object, accounts: AccountInfo[]) {
    const res = await postData(`Company`, data, accounts);
    return res;
}

export async function addCompanyDetail (data: object, accounts: AccountInfo[]) {
    const res = await postData(`CompanyDetail`, data, accounts);
    return res;
}

export async function addFavourites (data: object, accounts: AccountInfo[]) {
    const res = await postData(`Favourites`, data, accounts);
    return res;
}

export async function addNewUserApi (
    data: newUserPayloadType, accounts: AccountInfo[]) {
    return await postData('User', {...data, userRoleName: undefined, userStatus: true}, accounts);
}

export async function addFilterApi (data: object, accounts: AccountInfo[]) {
    return await postData('Filter', {...data}, accounts);
}

export async function addContact (data: object, accounts: AccountInfo[]) {
    const res = await postData(`Contact`, data, accounts);
    return res;
}

export async function addCompanyCategory (data: object,
    accounts: AccountInfo[]) {
    const res = await postData(`CompanyCategory`, data, accounts);
    return res;
}

export async function addFile (data: object, accounts: AccountInfo[]) {
    return await postData(`Files`, data, accounts);
}

export async function addNewUserRoleApi (data: newRoleType,
    accounts: AccountInfo[]) {
    return await postData('UserRole', {...data, permissions: undefined}, accounts);
}


export async function addNewCategoryApi(data: object, accounts: AccountInfo[]) {
    return await postData('Category', {...data, uploadedImg: undefined, uploadedImgDataUrl: undefined, updatedById: undefined},  accounts);
}

export async function addLog (data: object, accounts: AccountInfo[]) {
    try {
        const res = await postData('Logs', data, accounts);
        return {res, status: res.status};
    } catch (error) {
        return {error}
    }
}